import { FC } from 'react';
import Companies from '../Hotels/Companies';

type NewMainAreaProps = {
	brandsDescription: string;
};

const NewMainArea: FC<NewMainAreaProps> = (props) => {
	return (
		<div id="new-main-area">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-lg-10 col-xl-7 mt-md-5 mt-0">
						<div className="text-center">
							<Companies description={props.brandsDescription} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NewMainArea;
